"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@stocks/ui";

import { toImageUrl } from "@/shared/utils/imageUrl";

import { ItemThumbnail } from "./ItemThumbnail";

interface ZoomableImageProps {
  path: string;
  alt: string;
  className?: string;
}

/** 썸네일을 누르면 원본 크기로 확대해서 보여준다. */
export const ZoomableImage = ({ path, alt, className }: ZoomableImageProps) => (
  <Dialog>
    <DialogTrigger asChild>
      <button type='button' aria-label={`${alt} 확대 보기`} className='cursor-zoom-in'>
        <ItemThumbnail path={path} alt={alt} className={className} />
      </button>
    </DialogTrigger>
    <DialogContent className='max-w-3xl'>
      <DialogTitle>{alt}</DialogTitle>
      <DialogDescription className='sr-only'>사진 확대 보기</DialogDescription>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={toImageUrl(path)}
        alt={alt}
        className='max-h-[75vh] w-full rounded-md object-contain'
      />
    </DialogContent>
  </Dialog>
);
